import { render, staticRenderFns } from "./TaskDefaults.vue?vue&type=template&id=0d4ebfd9&lang=pug"
import script from "./TaskDefaults.vue?vue&type=script&lang=js"
export * from "./TaskDefaults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports